@let o = offer();
@let brand = o?.brand;
<section class="header">
    <div class="f-cross-start f-main-between f-wrap">
        <div class="header-content py-10 px-10 p-inset f-cross-center">
            <a [routerLink]="brand?.slug ? ['/brands', brand!.slug] : undefined">
                <img class="logo mr-10" [src]="(brand?.logo_url | bucket) ?? 'old/cloudigo_loader.svg'" [alt]="brand?.name" [fallback]/>
            </a>
            <div>
                <h2 class="m-0 font-extrabold" [paint]="o?.plan || 'NOTFOUND'">
                    {{o?.short_title||'Offer'}}
                </h2>
                <p class="m-0" paint="gray">{{usage()}}</p>
                <div class="f-cross-center mt-2 mb-16">
                    <span [paint]="o?.plan || 'NOTFOUND'" class="plan-border rounded px-20 py-2 font-semibold">{{o?.plan??'Basic' | humanize}}</span>
                </div>
                @if(canUse()){
                    <a mat-raised-button class="cta basic-horizontal" [routerLink]="['/get-the-app']">Get the app</a>
                } @else if(o?.plan == 'basic' || o?.plan == 'premium') {
                    <a mat-raised-button class="cta premium-horizontal" [routerLink]="['/premium']">Get Premium</a>
                }
            </div>
        </div>
        <div class="offer-loyalty py-10 px-10 f-main-center">
            @if(o?.tier_tree?.tiers?.length){
                <loyalty-card [offer]="o!"></loyalty-card>
                <!-- <section class="loyalty mt-8 text-center">
                </section> -->
            }
        </div>
    </div>
</section>
<mat-divider></mat-divider>
@if(o?.gallery_urls?.length; as len){
    <swiper-container #swiper class="my-8" init="false">
        @for(image of o?.gallery_urls; track image; let i = $index){
            <swiper-slide class="carousel-slide px-10 p-inset">
                <img [src]="image | bucket" alt="{{brand?.name}} Image {{i+1}}"/>
            </swiper-slide>
        }
    </swiper-container>
    <mat-divider></mat-divider>
}
<section class="offer-info pt-30">
    <div class="info-content f-main-between f-cross-start f-wrap pb-30 px-10 rgap-20 cgap-20">
        @if(o?.description){
            <div class="description colored-block">
                <h3 [paint]="o?.plan || 'NOTFOUND'" class="m-0 px-16 py-8">Info</h3>
                <mat-divider></mat-divider>
                <pre class="px-16 pb-8">{{o?.description}}</pre>
            </div>
        }
        <div class="terms colored-block">
            <h3 [paint]="o?.plan || 'NOTFOUND'" class="m-0 px-16 py-8">Terms & Conditions</h3>
            <mat-divider></mat-divider>
            <div class="list-view">
                <ng-scrollbar orientation="vertical">
                    <mat-list>
                        @for(term of artifical_terms(); track $index){
                            <mat-list-item>
                                <mat-icon matListItemIcon class="p-6 round plan-icon">{{term.icon}}</mat-icon>
                                <p class="m-0 term-item">{{term.text}}</p>
                            </mat-list-item>
                        }
                        @for(term of o?.terms; track $index){
                            <mat-list-item>
                                <mat-icon matListItemIcon class="p-6 round plan-icon">info</mat-icon>
                                <p class="m-0 term-item">{{term}}</p>
                            </mat-list-item>
                        }
                    </mat-list>
                </ng-scrollbar>
            </div>
        </div>
        <div class="related colored-block">
            <h3 [paint]="o?.plan || 'NOTFOUND'" class="m-0 px-16 py-8">Related Links</h3>
            <mat-divider></mat-divider>
            <div class="list-view">
                <ng-scrollbar orientation="vertical">
                    <mat-action-list>
                        <a mat-list-item [routerLink]="brand?.slug ? ['/brands', brand!.slug] : undefined">
                            <img matListItemAvatar [src]="(brand?.logo_url | bucket) ?? 'old/cloudigo_loader.svg'" alt="{{brand?.name || 'Brand'}} Logo" [fallback]/>
                            <span matListItemTitle>{{brand?.name}}</span>
                        </a>
                        @for(category of o?.categories; track category._id){
                            <a mat-list-item [routerLink]="['/search']" [queryParams]="{ s: category.name }">
                                <mat-icon matListItemIcon class="px-12" [svgIcon]="category.slug"></mat-icon>
                                <span matListItemTitle>{{category.name}}</span>
                            </a>
                        }
                        @for(city of cities(); track city){
                            <a mat-list-item [routerLink]="['/search']" [queryParams]="{ s: city }">
                                <mat-icon matListItemIcon class="px-12">room</mat-icon>
                                <span matListItemTitle>{{city}}</span>
                            </a>
                        }
                    </mat-action-list>
                </ng-scrollbar>
            </div>
        </div>
    </div>
</section>
@if(o?.stores?.at(0); as firstStore){
    <mat-divider></mat-divider>
    <section class="offer-info">
        <div class="px-16 p-inset py-30 rgap-20">
            <div class="outlets">
                <h3 [paint]="o?.plan || 'NOTFOUND'" class="m-0 py-8">Where you can use this offer</h3>
                <google-map mapId="offer-outlets" #map [zoom]="16" (mapInitialized)="centerMap()" [options]="{ fullscreenControl: true, mapTypeControl: false, clickableIcons: false }">
                    @for (store of o?.stores; track store._id) {
                        @let location = store.location;
                        @let geo = { lat: location.geo.y, lng: location.geo.x };
                        <div style="display: none;" class="cosmetic">
                            <!-- !Definite items to be used by map -->
                            <img class="brand-map-marker" #storeIcon [src]="(brand?.logo_url | bucket) ?? 'old/cloudigo_loader.svg'" [fallback] alt="{{brand?.name || 'Brand'}} Location"/>
                            <div #storeHeader>
                                <p class="m-0 font-bold">{{store.name}}</p>
                                <p class="m-0 font-light">{{[location.street,location.city,location.country] | join }}</p>
                            </div>
                            <div class="store-info-body" #storeContent>
                                <mat-divider></mat-divider>
                                <div class="mt-4 f-main-between f-cross-center">
                                    <p class="m-0">Opening Hours</p>
                                    @if(store.primary_phone){
                                        @let phone = store.primary_cc + ' ' + store.primary_phone;
                                        <a href="tel:{{phone}}" paint="blue">{{phone}}</a>
                                    }
                                </div>
                                <ul style="padding-left: 10px; list-style: none;">
                                    @for(timeslot of storeTimeslots()[store._id]; track timeslot[0]){
                                        @let weekday = timeslot[0];
                                        @let times = timeslot[1];
                                        <li>
                                            <span class="mr-8 store-timeslot">
                                                {{weekday}}
                                            </span>
                                            <span>{{times}}</span>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                        <map-advanced-marker #storeMarker="mapAdvancedMarker" [position]="geo" [content]="storeIcon" [title]="store.name" (mapClick)="openInfo(storeInfo)"></map-advanced-marker>
                        <map-info-window #storeInfo="mapInfoWindow" [position]="geo" [options]="{ pixelOffset: infoOffset, headerContent: storeHeader, content: storeContent }"></map-info-window>
                    }
                </google-map>
            </div>
        </div>
    </section>
}